import { theme } from '../../theme';
export const colorMap = {
    informative: {
        backgroundColor: theme.colors.BB20T,
        color: theme.colors.BB200,
    },
    positive: {
        backgroundColor: theme.colors.GR20T,
        color: theme.colors.GR200,
    },
    warning: {
        backgroundColor: theme.colors.YE20T,
        color: theme.colors.YE200,
    },
    negative: {
        backgroundColor: theme.colors.RE20T,
        color: theme.colors.RE200,
    },
};
export const iconPropsMap = {
    informative: {
        name: 'Information',
        color: theme.colors.BB100,
    },
    positive: {
        name: 'Checkmark',
        color: theme.colors.GR100,
    },
    warning: {
        name: 'WarningTriangle',
        color: theme.colors.YE100,
    },
    negative: {
        name: 'Alert',
        color: theme.colors.RE100,
    },
};
export const colorSelect = (variant) => colorMap[variant];
export const iconPropsSelect = (variant) => iconPropsMap[variant];
export const getStyles = (variant) => (Object.assign({}, colorSelect(variant)));
//# sourceMappingURL=styles.js.map